module.exports = "<blnd-activity object=\"vmo.order\"></blnd-activity>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/templates/detail.log.html
// module id = 640
// module chunks = 0